import type { CustomIconProps } from '../CustomIcon';

export const UserOutlineRejectedIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => (
  <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M19.6668 18.276V16.6093C19.6668 15.7253 19.3156 14.8774 18.6905 14.2523C18.0654 13.6272 17.2176 13.276 16.3335 13.276H9.66683C8.78277 13.276 7.93493 13.6272 7.30981 14.2523C6.68469 14.8774 6.3335 15.7253 6.3335 16.6093V18.276'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.9998 9.94267C14.8408 9.94267 16.3332 8.45028 16.3332 6.60933C16.3332 4.76839 14.8408 3.276 12.9998 3.276C11.1589 3.276 9.6665 4.76839 9.6665 6.60933C9.6665 8.45028 11.1589 9.94267 12.9998 9.94267Z'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle cx='6' cy='14.7775' r='6' fill='#DC0505' stroke='white' strokeWidth='2' />
    <path
      d='M3.96094 12.7384L6 14.7775M8.03906 16.8165L6 14.7775M6 14.7775L8.03906 12.7384M6 14.7775L3.96094 16.8165'
      stroke='white'
      strokeLinecap='round'
    />
  </svg>
);
